module.exports = __webpack_public_path__ + "static/media/logo.811f2231.svg";